export default function R_Examples() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Examples Component</h1>
      <p>This is the R_Examples tutorial section.</p>
    </div>
  );
}
